// Reads the member_email query parameter of the invite link. The invite emails put the address in
// the link without encoding it, and URLSearchParams decodes "+" as a space, which turned
// "name+tag@company.com" into "name tag@company.com". Here the raw value goes through
// decodeURIComponent, which keeps "+" as "+" and still decodes "%2B" or "%40".
export const readMemberEmailParam = (
  search: string | null | undefined
): string | null => {
  const query = (search || '').replace(/^\?/, '');

  for (const pair of query.split('&')) {
    const separator = pair.indexOf('=');
    const key = separator < 0 ? pair : pair.slice(0, separator);

    if (key !== 'member_email') {
      continue;
    }

    const rawValue = separator < 0 ? '' : pair.slice(separator + 1);
    let value = rawValue;

    try {
      value = decodeURIComponent(rawValue);
    } catch (err) {
      // malformed percent encoding: keep the raw value
    }

    return value.trim() || null;
  }

  return null;
};
